import React from 'react';

/**
 * Cella di tabella con bordo pieno.
 *
 * Stessa scelta di TableHeadCell: include solo `border border-line`,
 * invariante nelle 124 celle su 235 (53%) che usano la griglia a bordo
 * pieno. Le restanti si dividono fra nessun bordo (69) e bordo parziale
 * (42, in prevalenza border-b border-gray-100) e restano markup nativo.
 *
 * Tutto il resto (px-2 py-1 / px-3 py-2, align-top, whitespace-nowrap,
 * text-left / text-right, capitalize, font-mono, colonne sticky) varia da
 * cella a cella e resta nel className del chiamante.
 *
 * className non deve ridefinire spessore o colore del bordo.
 *
 * border-line = border-gray-200
 */
export default function TableCell({ className = '', ...props }) {
  return <td {...props} className={`border border-line ${className}`.trim()} />;
}
